import { render, staticRenderFns } from "./ProductoShow.vue?vue&type=template&id=48e35f0d"
import script from "./ProductoShow.vue?vue&type=script&lang=js"
export * from "./ProductoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports